import { useGetAllPOIsQuery } from "../Redux/service/POIS/POIs";

export const usePois = () => {
  const {
    data: allPois,
    isFetching,
    refetch,
  } = useGetAllPOIsQuery(
    {
      page: 1,
      limit: 10000,
      status: "true",
    },
    { refetchOnMountOrArgChange: true }
  );
  const pois = allPois?.data || [];

  const options = pois.map((form) => ({
    label: form.name,
    value: form.id,
  }));

  return { allPois, pois, options, isFetching, refetch };
};
